import React, { useState } from 'react';
import { MoveRight, MoveLeft, Compass, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/accueil/Footer';
import ChatWidget from '../components/accueil/ChatWidget';
import Navbar from '../components/accueil/Navbar';
import PageBanner from './Banner';
import useGlobale from '../components/global';



const ProcedureSceen = () => {
  const navigate = useNavigate();
  const { authenticated, user, logout } = useGlobale();
  const [showAlert, setShowAlert] = useState(false);

  const procedures = [
    {
      id: 'entry',
      title: "Venir au Niger",
      description: "Procédures d'entrée et formalités requises",
      icon: <MoveRight size={40} className="text-green-600" />,
      path: '/venir_au_niger',
      bgColor: 'bg-green-50'
    },
    {
      id: 'internal',
      title: "Voyage Interne",
      description: "Déplacements à l'intérieur du pays",
      icon: <Compass size={40} className="text-brand-600" />,
      path: '/procedure',
      bgColor: 'bg-brand-50'
    },
    {
      id: 'exit',
      title: "Sortir du Niger",
      description: "Procédures de sortie et documents nécessaires",
      icon: <MoveLeft size={40} className="text-blue-600" />,
      path: '/sortir_du_niger',
      bgColor: 'bg-blue-50'
    }
  ];

  const handleProcedureClick = (path) => {
    if (!authenticated) {
      setShowAlert(true);
      setTimeout(() => {
        navigate('/login', { 
          state: { from: path, message: "Connectez-vous pour accéder aux procédures" } 
        });
      }, 2000);
    } else {
      navigate(path);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar authenticated={authenticated} user={user} logout={logout} />
      <PageBanner currentPage="Procédures" />
      
      {showAlert && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in">
          <div className="bg-brand-50 border border-brand-100 text-brand-700 px-6 py-4 rounded-xl shadow-lg flex items-center gap-3">
            <AlertTriangle className="w-5 h-5 flex-shrink-0" />
            <p className="font-medium">Redirection vers la page de connexion...</p>
          </div>
        </div>
      )}

      <div className="flex-grow py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-black text-stone-800 mb-4 leading-tight">
              Quelle procédure souhaitez-vous suivre ?
            </h1>
            <p className="text-lg text-stone-600 max-w-2xl mx-auto">
              Sélectionnez votre situation pour obtenir la liste des procédures à suivre
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12">
            {procedures.map((proc) => (
              <button
                key={proc.id}
                onClick={() => handleProcedureClick(proc.path)}
                className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl 
                         transition-all duration-300 transform hover:-translate-y-1
                         border border-stone-100 hover:border-brand-200
                         focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  {/* Icon */}
                  <div className={`p-5 rounded-2xl ${proc.bgColor} group-hover:scale-110 transition-transform duration-300`}>
                    {proc.icon}
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-2xl font-bold text-stone-800 group-hover:text-brand-600 transition-colors">
                    {proc.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-stone-600 text-sm leading-relaxed">
                    {proc.description}
                  </p>
                  
                  {/* Arrow indicator */}
                  <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity">
                    <svg className="w-5 h-5 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* User Info */}
          {authenticated && user && (
            <div className="text-center">
              <div className="inline-flex items-center gap-2 bg-brand-50 border border-brand-100 px-6 py-3 rounded-xl">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <p className="text-stone-700">
                  Connecté en tant que <span className="font-bold text-brand-700">{user.first_name} {user.last_name}</span>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default ProcedureSceen;